// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_cPJGn","footerFullWidth":"index_footerFullWidth_xzp6k","inner":"index_inner_flrAC","logo":"index_logo_VMCpe"};